export default "__VITE_ASSET__D4TA9pV$__"